export const MoreVerticalIcon = ({ fillColor = "white", ...props }: any) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <g transform="rotate(-90 11 11)">
      <path
        d="M4.58301 8.97917C5.70009 8.97917 6.60432 9.88263 6.60449 10.9997C6.60449 12.1169 5.7002 13.0212 4.58301 13.0212C3.46597 13.021 2.5625 12.1168 2.5625 10.9997C2.56268 9.88274 3.46608 8.97934 4.58301 8.97917ZM4.58301 9.35417C3.67462 9.35434 2.93768 10.0913 2.9375 10.9997C2.9375 11.9082 3.67451 12.646 4.58301 12.6462C5.49165 12.6462 6.22949 11.9083 6.22949 10.9997C6.22932 10.0912 5.49154 9.35417 4.58301 9.35417Z"
        fill={fillColor}
        stroke={fillColor}
      />
      <path
        d="M17.4163 8.97917C18.5334 8.97917 19.4376 9.88263 19.4378 10.9997C19.4378 12.1169 18.5335 13.0212 17.4163 13.0212C16.2993 13.021 15.3958 12.1168 15.3958 10.9997C15.396 9.88274 16.2994 8.97934 17.4163 8.97917ZM17.4163 9.35417C16.508 9.35434 15.771 10.0913 15.7708 10.9997C15.7708 11.9082 16.5078 12.646 17.4163 12.6462C18.325 12.6462 19.0628 11.9083 19.0628 10.9997C19.0626 10.0912 18.3249 9.35417 17.4163 9.35417Z"
        fill={fillColor}
        stroke={fillColor}
      />
      <path
        d="M10.9997 8.97917C12.1168 8.97917 13.021 9.88263 13.0212 10.9997C13.0212 12.1169 12.1169 13.0212 10.9997 13.0212C9.88263 13.021 8.97917 12.1168 8.97917 10.9997C8.97934 9.88274 9.88274 8.97934 10.9997 8.97917ZM10.9997 9.35417C10.0913 9.35434 9.35434 10.0913 9.35417 10.9997C9.35417 11.9082 10.0912 12.646 10.9997 12.6462C11.9083 12.6462 12.6462 11.9083 12.6462 10.9997C12.646 10.0912 11.9082 9.35417 10.9997 9.35417Z"
        fill={fillColor}
        stroke={fillColor}
      />
    </g>
  </svg>
);
